import '../../assets/css/style.min.css'
import { initializeApp } from "firebase/app";
import { getAuth, onAuthStateChanged } from "firebase/auth";
import { g, getLast3Months, getLastDayOfMonth, getPercentage, initU, initWallet, log, monthNames, t, timeFrom } from "../../../../utils/index"
import { collection, doc, getCountFromServer, getDoc, getDocs, getFirestore, orderBy, query, where } from "firebase/firestore"
import { percentageBar, pieChart, radialBar } from '../../assets/js/scripts';
import { firebaseConfig } from '../../components/config';
import { Dashboard } from '../../components/dashboard';

const app = initializeApp(firebaseConfig);
const auth = getAuth();
const firestore = getFirestore()

const dashboardApp = "ride"

var loaderDiv = g("loader-wrapper");

loaderDiv.addEventListener("transitionend", function () {
  loaderDiv.style.display = "none";
}, true);

const removeSplash = () => {
  loaderDiv.style.opacity = 0.0;
}

onAuthStateChanged(auth, async (user) => {
  if (user) {
    const dashboard = new Dashboard(app, user, dashboardApp)

    dashboard.init(async () => {
      initU(user)

      const rideV2Doc = await getDoc(doc(firestore, "system/rideV2"))

      if (rideV2Doc.exists()) {
        initWallet(firebaseConfig.messagingSenderId, (mResult) => {
          g("_bal").innerText = `KWA${mResult.balance}`
          g("_bal2").innerText = `KWA${mResult.balance}`
        })

        const rideV2DocData = rideV2Doc.data()

        const localitiesObj = rideV2DocData.localities
        var localities = []

        for (const key in localitiesObj) {
          if (Object.hasOwnProperty.call(localitiesObj, key)) {
            const locality = localitiesObj[key];
            locality["key"] = key

            localities.push(locality)
          }
        }

        const localityKeys = localities.map(locality => {
          return locality.key
        })

        var dateToday = new Date();
        dateToday.setHours(0, 0, 0, 0);

        const totalPaidRidesTodayCol = collection(firestore, "rides")
        const totalPaidRidesTodayQuery = query(
          totalPaidRidesTodayCol,
          ...[where("timestamp", ">=", dateToday)]
        )

        getDocs(totalPaidRidesTodayQuery).then((totalPaidRidesToday) => {
          var total = 0
          var totalActual = 0

          totalPaidRidesToday.forEach((doc) => {
            const rideData = doc.data()

            total += rideData.estimatedFare

            if (rideData.stage > 4) {

            } else {
              if (rideData.stage >= 3) {
                if (rideData.stage == 3) {
                  totalActual += rideData.estimatedFare
                } else {
                  totalActual += rideData.total
                }
              }
            }
          })

          g("total_today_earning").innerText = `ZMW${Math.round((rideV2DocData.comission / 100 * total + Number.EPSILON) * 100) / 100}`
          g("total_today").innerText = `ZMW${Math.round((total + Number.EPSILON) * 100) / 100}`

          g("total_today_earning_a").innerText = `ZMW${Math.round((rideV2DocData.comission / 100 * totalActual + Number.EPSILON) * 100) / 100}`
          g("total_today_a").innerText = `ZMW${Math.round((totalActual + Number.EPSILON) * 100) / 100}`
        })

        const accountCol = collection(firestore, "account")
        getCountFromServer(accountCol).then((accountSnapshot) => { g("users_count").innerText = accountSnapshot.data().count })

        const rideCol = collection(firestore, "ride")
        const rideQuery = query(rideCol, where("isRegistered", "==", true))
        getCountFromServer(rideQuery).then((rideSnapshot) => { g("driver_count").innerText = rideSnapshot.data().count })

        const ridesCol = collection(firestore, "rides")
        getCountFromServer(ridesCol).then((ridesSnapshot) => { g("rides_count").innerText = ridesSnapshot.data().count })





        //pending drivers
        const activeDriversColQuery = query(rideCol, where("isRegistered", "==", false), orderBy("timestamp", "desc"))
        const activeDriversColQuerySnapshot = await getDocs(activeDriversColQuery)
        activeDriversColQuerySnapshot.forEach(driverSnapshot => {
          const driverData = driverSnapshot.data()

          g('active_drivers').appendChild(t(`<tr class="tbl__row">
            <td class="tbl__cell" role="cell">
              <div class="flex items-center">
                <div class="line-height-xs">
                  <p class="margin-bottom-xxxxs">${driverSnapshot.id}</p>
                </div>
              </div>
            </td>
    
            <td class="tbl__cell" role="cell">${driverData.timestamp.toDate()}</td>
    
            <td class="tbl__cell" role="cell">${driverData.currentLocality}</td>
    
            <td class="tbl__cell" role="cell">
              <span class="inline-block text-sm bg-warning bg-opacity-20% color-danger-darker radius-full padding-y-xxxs padding-x-xs">Pending</span>
            </td>
    
            <td class="tbl__cell text-right" role="cell"><a href="./users/user/?id=${driverSnapshot.id}" class="btn btn--primary">Verify</a></td>
          </tr>`))
        })



        async function gL3mStats(startDates = []) {
          var labels = []
          var d1 = []
          var d2 = []

          for (let x = 0; x < startDates.length; x++) {
            const startDate = new Date(startDates[x]);
            log(startDate)

            const completedRidesThisMonthQuery = query(ridesCol, ...[
              where("timestamp", ">=", startDate),
              where("timestamp", "<=", getLastDayOfMonth(startDate.getFullYear(), startDate.getMonth())),
              where("stage", "==", 4)
            ])

            const qs = await getDocs(completedRidesThisMonthQuery)

            var cTotal = 0

            for (let x = 0; x < qs.docs.length; x++) {
              const element = qs.docs[x];
              cTotal += element.data().estimatedFare
            }

            labels.push(monthNames[startDate.getMonth()])
            d1.push(cTotal)
            d2.push(getPercentage(15, cTotal))
          }

          return {
            labels: labels,
            d1: d1,
            d2: d2
          }
        }

        const l3mStats = await gL3mStats(getLast3Months(3))

        var columnChart5 = g('monthly-column-chart');

        new Chart({
          element: columnChart5,
          type: 'column',
          stacked: true,
          xAxis: {
            line: true,
            labels: l3mStats.labels,
            ticks: true
          },
          yAxis: {
            labels: true
          },
          datasets: [
            // { data: [1, 2, 3, 12, 8, 7, 10, 4, 9, 5, 16, 3] },
            // { data: [4, 8, 10, 12, 15, 11, 7, 3, 5, 2, 12, 6] }

            { data: l3mStats.d1 },
            { data: l3mStats.d2 }
          ],
          column: {
            width: '60%',
            gap: '2px',
            radius: '4px'
          },
          tooltip: {
            enabled: true,
            customHTML: function (index, chartOptions) {
              var html = '<p class="margin-bottom-xxs">Total ZMW' + chartOptions.datasets[0].data[index] + '</p>';
              html = html + '<p class="flex items-center"><span class="height-xxxs width-xxxs radius-50% bg-primary margin-right-xxs"></span>' + chartOptions.datasets[0].data[index] + '</p>';
              html = html + '<p class="flex items-center"><span class="height-xxxs width-xxxs radius-50% bg-contrast-higher margin-right-xxs"></span>' + chartOptions.datasets[1].data[index] + '</p>';
              return html;
            },
            position: 'top'
          },
          animate: true
        });




        removeSplash()




        async function gCount(collectionName, queries) {
          const col = collection(firestore, collectionName)
          const colQuery = query(col, ...queries)
          const colSnapshot = await getCountFromServer(colQuery)
          return colSnapshot.data().count
        }

        async function gCountV2(collectionName, q) {
          const col = collection(firestore, collectionName)
          const colQuery = query(col, q)
          const colSnapshot = await getCountFromServer(colQuery)
          return colSnapshot.data().count
        }

        //
        const newUsersCount = await gCountV2("account", where("timestamp", ">=", dateToday))
        g('new_users_count').innerText = newUsersCount
        g('_users2').innerText = newUsersCount

        g('new_drivers_count').innerText = await gCount("ride", [where("isRegistered", "==", false)])
        g('completed_rides_count').innerText = await gCount("rides", [where("stage", "==", 4)])

        async function gCountsTotal(dates, collectionName) {
          var counts = []

          for (let index = 0; index < dates.length; index++) {
            const date = dates[index];

            const cloned = new Date(date.getTime())

            cloned.setHours(cloned.getHours() + 24)

            const n = await gCount(collectionName, [
              where("timestamp", ">", date),
              where("timestamp", "<", cloned)
            ])

            counts.push({ v: n, date: date })
          }

          counts.sort(function (a, b) {
            // Turn your strings into dates, and then subtract them
            // to get a value that is either negative, positive, or zero.
            return new Date(b.date) - new Date(a.date);
          })

          return counts.map(o => o.v).reverse()
        }

        async function gCountTotalCompleted(dates, collectionName) {
          var counts = []

          for (let index = 0; index < dates.length; index++) {
            const date = dates[index];

            const cloned = new Date(date.getTime())
            cloned.setHours(cloned.getHours() + 24)

            const n = await gCount(
              collectionName,
              [
                where("stage", "==", 4),
                where("timestamp", ">", date),
                where("timestamp", "<", cloned)
              ]
            )

            counts.push({ v: n, date: date })
          }

          counts.sort(function (a, b) {
            // Turn your strings into dates, and then subtract them
            // to get a value that is either negative, positive, or zero.
            return new Date(b.date) - new Date(a.date);
          })

          return counts.map(o => o.v).reverse()
        }

        async function gCountLocality(collectionName) {
          var counts = []

          for (let x = 0; x < localityKeys.length; x++) {
            const key = localityKeys[x];
            const n = await gCount(collectionName, [where("stage", "==", 4), where("locality", "==", key)])
            counts.push({ count: n, locality: key })
          }

          return counts
        }

        // Daily performance
        const columnDays = timeFrom(dateToday, 8, 'day').reverse()
        const columnDates = timeFrom(dateToday, 8, 'date').reverse()

        log(columnDates)

        const countsTotal = await gCountsTotal(columnDates, "rides")
        const countsTotalCompleted = await gCountTotalCompleted(columnDates, "rides")

        var columnChart3 = document.getElementById('column-chart-3');
        if (columnChart3) {
          new Chart({
            element: columnChart3,
            type: 'column',
            xAxis: {
              line: true,
              labels: columnDays,
              ticks: true
            },
            yAxis: {
              labels: true
            },
            datasets: [
              { data: countsTotal },
              { data: countsTotalCompleted }
            ],
            column: {
              width: '60%',
              gap: '2px',
              radius: '4px'
            },
            tooltip: {
              enabled: true,
              customHTML: function (index, chartOptions) {
                var html = '<p class="margin-bottom-xxs">Total ' + chartOptions.datasets[0].data[index] + '</p>';
                html = html + '<p class="flex items-center"><span class="height-xxxs width-xxxs radius-50% bg-primary margin-right-xxs"></span>' + chartOptions.datasets[0].data[index] + '</p>';
                html = html + '<p class="flex items-center"><span class="height-xxxs width-xxxs radius-50% bg-contrast-higher margin-right-xxs"></span>' + chartOptions.datasets[1].data[index] + '</p>';
                return html;
              },
              position: 'top'
            },
            animate: true
          });
        };

        async function getMcounts(collectionName, targets, completed) {
          var counts = []

          if (completed) {
            for (let x = 0; x < targets.length; x++) {
              const key = targets[x];
              const t = await gCount(collectionName, [
                where("locality", "==", key),
                where("timestamp", ">=", dateToday),
                where("stage", "==", 4)
              ])

              counts.push(t)
            }
          } else {
            for (let x = 0; x < targets.length; x++) {
              const key = targets[x];
              const t = await gCount(collectionName, [
                where("locality", "==", key),
                where("timestamp", ">=", dateToday)
              ])

              counts.push(t)
            }
          }

          return counts
        }

        const localityCountsTotal = await getMcounts("rides", localityKeys, false)
        const localityCountsCompletedTotal = await getMcounts("rides", localityKeys, true)

        var columnChart4 = document.getElementById('column-chart-4');
        if (columnChart4) {
          console.log(localityCountsTotal);
          console.log(localityCountsCompletedTotal);

          new Chart({
            element: columnChart4,
            type: 'column',
            stacked: true,
            xAxis: {
              line: true,
              labels: localityKeys,
              ticks: true
            },
            yAxis: {
              labels: true
            },
            datasets: [
              // { data: [1, 2, 3, 12, 8, 7, 10, 4, 9, 5, 16, 3] },
              // { data: [4, 8, 10, 12, 15, 11, 7, 3, 5, 2, 12, 6] }

              { data: localityCountsTotal },
              { data: localityCountsCompletedTotal }
            ],
            column: {
              width: '60%',
              gap: '2px',
              radius: '4px'
            },
            tooltip: {
              enabled: true,
              customHTML: function (index, chartOptions) {
                var html = '<p class="margin-bottom-xxs">Total ' + chartOptions.datasets[0].data[index] + '</p>';
                html = html + '<p class="flex items-center"><span class="height-xxxs width-xxxs radius-50% bg-primary margin-right-xxs"></span>' + chartOptions.datasets[0].data[index] + '</p>';
                html = html + '<p class="flex items-center"><span class="height-xxxs width-xxxs radius-50% bg-contrast-higher margin-right-xxs"></span>' + chartOptions.datasets[1].data[index] + '</p>';
                return html;
              },
              position: 'top'
            },
            animate: true
          });
        }

        // charts
        const getBg = () => {
          return Math.floor(Math.random() * 16777215).toString(16);
        }

        const localityStats = await gCountLocality("rides")

        const percentage = 100
        var total = 0

        for (let index = 0; index < localityStats.length; index++) {
          const localityStat = localityStats[index];
          total += localityStat.count
        }

        const ratioPart = percentage / total

        for (let index = 0; index < localityStats.length; index++) {
          const locality = localityStats[index];

          const rColor = getBg()



          g('locality_activity').appendChild(t(`<li class="flex items-center">
            <span class="pct-bar__bullet margin-right-xxs" aria-hidden="true" style="background-color: #${rColor};"></span>
            <span class="text-sm">${locality.locality} (<i class="js-pct-bar__value" data-pct-bar-bg="bg-primary" data-pct-bar-style="background-color: #${rColor};">${locality.count * ratioPart}%</i>)</span>
          </li>`))

          g('locality_activity_pie').appendChild(t(`<li class="flex items-center">
            <span class="pie-chart__bullet margin-right-xxs" aria-hidden="true"  style="background-color: #${rColor};"></span>
            <span class="text-sm">${locality.locality} (<i class="js-pie-chart__value" data-pie-chart-style="fill: #${rColor};">${locality.count * ratioPart}%</i>)</span>
          </li>`))

          g('locality_activity_donut').appendChild(t(`<li class="flex items-center">
            <span class="pie-chart__bullet margin-right-xxs" aria-hidden="true" style="background-color: #${rColor};"></span>
            <span class="text-sm">${locality.locality} (<i class="js-pie-chart__value" data-pie-chart-style="fill: #${rColor};">${locality.count * ratioPart}%</i>)</span>
          </li>`))

          g('locality_activity_radial').appendChild(t(`<li class="flex items-center">
            <span class="radial-bar__bullet margin-right-xxs" aria-hidden="true" style="background-color: #${rColor};"></span>
            <span class="text-sm">${locality.locality} (<i class="js-radial-bar__value" data-radial-bar-color="color-primary" data-pct-bar-style="background-color: #${rColor};">${locality.count * ratioPart}%</i>)</span>
          </li>`))
        }




        pieChart()
        percentageBar()
        radialBar()
      }
    }, () => { location.replace('../../subscribe/?app=ride') })
  } else location.replace('../../account/login')
})

require("../../assets/js/scripts")

